import { Component, ViewChild } from '@angular/core';
import { NavController, PopoverController, ModalController, AlertController, Content, Platform } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { PopoverPage } from '../popover/popover';
import { AngularFireAuth } from 'angularfire2/auth';
import { ProfileviewPage } from '../profileview/profileview';
import { EmailProvider } from '../../providers/email/email';
import { ComplaintsAndSuggestionsPage } from '../complaints-and-suggestions/complaints-and-suggestions';
import { RetirementCalculatorPage } from '../retirement-tools/retirement-calculator/retirement-calculator';
import { LoginPage } from '../login/login';
import { ToolsPage } from '../tools/tools';
import { PrivacyPolicyPage } from '../privacy-policy/privacy-policy';
import { TermsAndConditionsPage } from '../terms-and-conditions/terms-and-conditions';

interface Users {
  avatar: string,
  is_admin: boolean,
  order: number,
  id: string
}

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})

export class HomePage {
  @ViewChild(Content) content: Content;
  isDesktop: Boolean = true;
  proofMail = {
    email: "",
    name: ""
  }
  user_type = '';
  user_name = '';
  usersCollection: AngularFirestoreCollection<Users>;
  itemSel: any;
  users: Users[];
  canReorder: boolean = false;
  today = new Date();
  selected = 1;
  user_img: any;
  status: string;
  userId: string;
  alertPrevent: boolean = false;
  destroy: boolean = false;

  constructor(public navCtrl: NavController, public platform: Platform, private fire: AngularFirestore, public popoverCtrl: PopoverController, public modalCtrl: ModalController, public alertCtrl: AlertController, private FireAuth: AngularFireAuth, public emailProvider: EmailProvider) {
    //this.navCtrl.push(ExpenseCalculatorPage);
    //console.log(this.destroy);
    this.isDesktop = this.platform.is('core');
    this.FireAuth.auth.onAuthStateChanged(data => {
      if (data && data.uid) {
        this.userId = data.uid;
        this.fire.doc("Users/" + data.uid).snapshotChanges().subscribe(document => {
          if (document.payload.exists) {
            let Switch: number = document.payload.data() && document.payload.data().type ? document.payload.data().type : 0;
            this.user_name = document.payload.data() && document.payload.data().name ? document.payload.data().name : '';
            this.user_img = document.payload.data() && document.payload.data().profile && document.payload.data().profile.downloadURL ? document.payload.data().profile.downloadURL : '';
            if (Switch == 2) {
              this.user_type = 'Usuario';
              this.selected = 2;
              this.itemSel = document.payload.data();
            } else if (Switch == 3) {
              this.user_type = 'Coach';
              this.selected = 1;
            } else {
              this.user_type = 'Administrador';
              this.selected = 2;
            }
            this.content.resize();
          }
        });
      } else {
        this.navCtrl.setRoot(LoginPage);
      }
    });
  }

  segmentChanged(event) {
    this.selected = event.value;
  }

  calculator() {
    this.navCtrl.push(RetirementCalculatorPage);
  }

  tools() {
    const modal = this.modalCtrl.create(ToolsPage);
    this.destroy = true;
    //console.log(this.destroy);
    modal.present();
  }

  destroyReturn(ev) {
    this.destroy = ev;
    //console.log(this.destroy);
  }

  ionViewDidEnter() {
    this.usersCollection = this.fire.collection('users', ref => ref.orderBy("order", 'desc'));
    this.usersCollection.snapshotChanges().subscribe(data => {
      this.users = data.map(item => {
        return {
          avatar: item.payload.doc.data().avatar,
          is_admin: item.payload.doc.data().is_admin,
          order: item.payload.doc.data().order,
          id: item.payload.doc.id
        }
      })
    });
  }

  reorderItems(indexes: any) {
    if (this.canReorder) {
      let batch = this.fire.firestore.batch();
      let element = this.users[indexes.from];
      this.users.splice(indexes.from, 1);
      this.users.splice(indexes.to, 0, element);
      this.users.forEach((item: Users, index: number) => {
        if (item.order != index) {
          let ref = this.fire.collection('users').doc(item.id).ref;
          batch.update(ref, { order: index });
        }
      });
      batch.commit().then(() => {
      }).catch(error => {
        ////console.error(error);
      });
    }
  }

  presentPopover(event) {
    let popover = this.popoverCtrl.create(PopoverPage);
    popover.present({ ev: event });
  }

  menuClick(x) {
    if (this.selected == x) {
      this.selected = 0;
    } else {
      this.selected = x;
    }
  }

  logout() {
    this.FireAuth.auth.signOut().then(() => { });
  }

  profile() {
    let modal = this.modalCtrl.create(ProfileviewPage);
    modal.present();
  }


  complaintsAndSuggestions() {
    let modal = this.modalCtrl.create(ComplaintsAndSuggestionsPage);
    modal.present();
  }

  privacyPolicy() {
    let modal = this.modalCtrl.create(PrivacyPolicyPage);
    modal.present();
  }

  termsAndConditions() {
    let modal = this.modalCtrl.create(TermsAndConditionsPage);
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts